// When firing preload functions we don't have experience tracker started thus we can only annotate the request through URL match

export function setFallbackAtlExperience(exp: string): void {
	window['GLOBAL_FALLBACK_ATL_EXP'] = exp;
}
